<template>
    <div>

        <div class="mb-3">
            <div class="row">
                <div class="col col-12">
                    <div class="progress" style="height: 20px !important;">
                        <div class="progress-bar" role="progressbar" :style="'width: ' + percentual + '%;'">
                            {{ percentual }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col col-12 col-md-3">
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <a class="nav-link" href="#" @click.prevent="abrir('clinica')" :class="aba == 'clinica' ? 'active' : ''">Clínica</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('profissionais')" :class="aba == 'profissionais' ? 'active' : ''">Profissionais</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('procedimentos')" :class="aba == 'procedimentos' ? 'active' : ''">Procedimentos</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('agendas')" :class="aba == 'agendas' ? 'active' : ''">Agendas</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('particupar')" :class="aba == 'particupar' ? 'active' : ''">Valores Particulares</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('operadoras-principais')" :class="aba == 'operadoras-principais' ? 'active' : ''">Operadoras Principais</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('operadoras')" :class="aba == 'operadoras' ? 'active' : ''">Todas as Operadoras</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('contratos')" :class="aba == 'contratos' ? 'active' : ''">Contratos</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('precos')" :class="aba == 'precos' ? 'active' : ''">Tabelas de Preços</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('usuarios')" :class="aba == 'usuarios' ? 'active' : ''">Usuários</a>
                    <a class="nav-link" href="#" @click.prevent="abrir('concluir')" :class="aba == 'concluir' ? 'active' : ''">Concluir</a>
                </div>
            </div>

            <div class="col col-12 col-md-9">
                <div class="tab-content" id="v-pills-tabContent">
                    <!-- Clínica -->
                    <div v-if="aba == 'clinica'">
                        <clinicas :setup="true" />
                    </div>

                    <!-- Médicos -->
                    <div v-if="aba == 'profissionais'">
                        <prestadores :setup="true" />
                    </div>

                    <!-- Usuários -->
                    <div v-if="aba == 'usuarios'">
                        <cadastro-usuarios :setup="true" />
                    </div>

                    <!-- Procedimentos -->
                    <div v-if="aba == 'procedimentos'">
                        <cadastro-procedimentos :setup="true" />
                    </div>

                    <!-- Valores Particulares -->
                    <div v-if="aba == 'particupar'">
                        <valores-particulares :setup="true" />
                    </div>

                    <!-- Agendas -->
                    <div v-if="aba == 'agendas'">
                        <setup-agendas />
                    </div>

                    <!-- Operadoras Principais -->
                    <div v-if="aba == 'operadoras-principais'">
                        <setup-operadoras />
                    </div>

                    <!-- Todas as Operadoras -->
                    <div v-if="aba == 'operadoras'">
                        <cadastro-operadoras :setup="true" />
                    </div>

                    <!-- Contrato de Operadodas -->
                    <div v-if="aba == 'contratos'">
                        <cadastro-contrato-operadora :setup="true" />
                    </div>

                    <!-- Validação de Preços -->
                    <div v-if="aba == 'precos'">
                        <valid-precos :setup="true" />
                    </div>

                    <!-- Concluir Configurações Iniciais -->
                    <div v-if="aba == 'concluir'">
                        <setup-conclusao />
                    </div>

                </div>

            </div>
        </div>

        <setup-clinica v-if="false" />
    </div>
</template>

<script>
import SetupClinica from './SetupClinica.vue';
import Clinicas from '../cadastros/items/Clinicas.vue';
import Prestadores from '../cadastros/items/Prestadores.vue';
import CadastroUsuarios from '../cadastros/items/CadastroUsuarios.vue';
import CadastroOperadoras from '../cadastros/items/CadastroOperadoras.vue';
import SetupOperadoras from './SetupOperadoras.vue';
import SetupAgendas from './SetupAgendas.vue';
import CadastroProcedimentos from '../cadastros/items/CadastroProcedimentos.vue';
import CadastroContratoOperadora from '../cadastros/items/CadastroContratoOperadora.vue';
import ValoresParticulares from '../cadastros/items/ValoresParticulares.vue';
import ValidPrecos from '../cadastros/validacao/ValidPrecos.vue';
import SetupConclusao from './SetupConclusao.vue';

export default {
    data() { 
        return { 
            passo: 1, 
        };
    },

    props: ['aba'],

    components: { 
        SetupClinica,
        Clinicas, 
        Prestadores, 
        CadastroUsuarios, 
        CadastroOperadoras,
        SetupOperadoras,
        CadastroProcedimentos,
        CadastroContratoOperadora, 
        SetupAgendas, 
        ValoresParticulares, 
        ValidPrecos, 
        SetupConclusao, 
    },

    computed: { 
        percentual: function () { 
            let step = 0;

            switch (this.aba) {
                case 'clinica': 
                    step = 0;
                    break;
                case 'profissionais': 
                    step = 1;
                    break;
                case 'procedimentos':
                    step = 2;
                    break;
                case 'agendas':
                    step = 3;
                    break;
                case 'particupar':
                    step = 4;
                    break;
                case 'operadoras-principais':
                    step = 5;
                    break;
                case 'operadoras':
                    step = 6;
                    break;
                case 'contratos':
                    step = 7;
                    break;
                case 'precos':
                    step = 8;
                    break;
                case 'usuarios':
                    step = 9;
                    break;
                case 'concluir':
                    step = 10;
                    break;
            }

            return Math.round(( step / 10) * 100 );
        },
    },

    methods: { 
        abrir(aba) { 
          if ( aba != this.aba ) { 
            this.$router.push({ path: '/setup/' + aba });
          }
      },
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Configurações Iniciais", path: "/setup/clinica" },
        ]);
    }
}
</script>